<template>
    <div class="mainBody">
        <div class="searchBox">
            <div class="searchGroup">
                <label>推广达人编号：</label>
                <el-input v-model="search_Obj.f_member_code" clearable @keyup.enter.native="doSearch"></el-input>
            </div>
            <div class="searchGroup">
                <label>姓名：</label>
                <el-input v-model="search_Obj.f_name" clearable @keyup.enter.native="doSearch"></el-input>
            </div>
            <div class="searchGroup">
                <label>手机号：</label>
                <el-input v-model="search_Obj.f_cellphone" clearable @keyup.enter.native="doSearch"></el-input>
            </div>
            <div class="searchGroup">
                <label>结算批次：</label>
                <el-input v-model="search_Obj.f_batch" clearable @keyup.enter.native="doSearch"></el-input>
            </div>
            <el-button type="primary" plain @click.native="doSearch">搜索</el-button>
            <Btns :menu_id="menu_id" :menus="main_btns" @on_btnclk="btnClick"></Btns>
        </div>
        <div class="dataBox">
            <el-table :data="tableData" :default-sort="sortData" @sort-change="sortChange" @selection-change="selectChanges" v-loading="loading" border stripe>
                <el-table-column prop="member_code" label="推广者编号" sortable="custom"></el-table-column>
                <el-table-column prop="name" label="姓名" sortable="custom"></el-table-column>
                <el-table-column prop="cellphone" label="手机号" sortable="custom"></el-table-column>
                <el-table-column prop="batch" label="批次" sortable="custom"></el-table-column>
                <el-table-column prop="monty" label="结算金额" sortable="custom"></el-table-column>
                <el-table-column prop="settled_time" label="结算时间" sortable="custom"></el-table-column>
                <el-table-column prop="creator_name" label="操作人" sortable="custom"></el-table-column>
                <el-table-column label="操作" width="120" align="center">
                    <template slot-scope="scope">
                        <LabBtns :menu_id="menu_id" :row="scope.row" :index="scope.$index" :menus="lab_btns" @on_btnclk="labelClick"></LabBtns>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pageBox">
            <el-pagination background layout="total, prev, pager, next, jumper" :current-page="current" :total="total" @current-change="pageChange"></el-pagination>
        </div>
        <Edit
            width="600px"
            :id="model_id"
            :title="edit_title"
            :isshow="editshow"
            @on-close="closeEditDialog"
            @on-save-ok="saveOk">
        </Edit>
        <Info
            width="600px"
            :id="model_id"
            title="查看结算记录"
            :isshow="infoshow"
            @on-close="closeInfoDialog">
        </Info>
    </div>
</template>

<script>
import Btns from "@/components/common/btns"
import LabBtns from "@/components/common/labbtns"
import Edit from "./edit"
import Info from "./info"
import listutil from "@/libs/listutil"

export default {
    name: 'promotionSettledList',
    mixins: [listutil],
    components: {Edit, Info, Btns, LabBtns},
    data() {
        return {
            m_name: '结算记录',
            menu_id: 7710,
            list_url: "/api/admin/promotionsettled/list",
            search_Obj: {
                f_member_code: '',
                f_name: '',
                f_cellphone: '',
                f_batch: '',
            },
            del_Obj:{
                url:'/api/admin/promotionsettled/del',
                data:{
                    ids:''
                }
            },
            enu_name: [],
        };
    },
    methods: {}
};
</script>